import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdModeEdit, MdSearch } from "react-icons/md";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

export class InstructorTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminInstructorTable.target,
          content: (
            <div>
              <p>{tourMessages.adminInstructorTable.title}</p>
              <p
                style={{ color: "blue", fontStyle: "italic", fontSize: "10px" }}
              >
                {tourMessages.adminInstructorTable.content}
              </p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP" },
        },
        tourMessages.default,
      ],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.showJoyRideOnTable) {
      this.setState({ run: true });
      this.props.stopJoyRideAtDataTable();
    }
  }
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.routeChange();
      }
    }
  };
  render() {
    const columns = [
      {
        Header: "First Name",
        accessor: "firstName",
        maxWidth: 270,
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Email",
        accessor: "emailAddress",
        minWidth: 100,
      },
      {
        Header: "Mobile Number",
        accessor: "mobileNumber",
        minWidth: 100,
      },

      {
        Header: "Business Name",
        accessor: "businessName",
      },
    ];

    const {
      match,
      fetching,
      data,
      pages,
      filterData,
      error,
      selectRow,
      deleteCategory,
      ViewInstructorSelectRow,
      page,
      pageSize,
      setPageNumber,
      setPageSize,
    } = this.props;
    const { run, steps, stepIndex } = this.state;
    const actions = [
      {
        name: "view",
        btnText: "View",
        btnAction: ViewInstructorSelectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch,
      },
      {
        name: "edit",
        btnText: "Edit",
        btnAction: selectRow,
        btnClass: "btn-primary",
        btnIcon: MdModeEdit,
      },
    ];

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Card className="joyride9">
          <CardHeader>Instructors</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <DataTable
              columns={columns}
              loading={fetching}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteCategory}
              selectRow={selectRow}
              hideActions={false}
              showInstructorActions={true}
              ViewInstructorSelectRow={ViewInstructorSelectRow}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="filter"
              searchPlaceholder="Search"
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default InstructorTable;
